import React from "react";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Icon
} from "semantic-ui-react";
import "./index.css";
const LisData = ({ currency, componentData, percentage }) => {
  const { header, data } = componentData;
  var headers = ["MARGIN-BY-STORE", "MARGIN"];
  let csvObj = data.values || [];
  if (csvObj[0]) {
    if (csvObj[0].category)
      if (csvObj[0].category.category) {
        headers = ["MARGIN-BY-STORE", "MARGIN"];
      }
  }

  const displayValue = (value, displayCurrency = "", percentage = "") => {
    if (value == undefined || value <= 0 || value == "No Sales") {
      return "-";
    }

    return displayCurrency + " " + value + " " + percentage;
  };

  return (
    <Grid.Column verticalAlign="top">
      <Grid.Row style={styles.heading}>
        <Header as="h5" style={styles.headingText}>
          {header}
        </Header>
      </Grid.Row>
      <div className="margin-by-store">
        {data.values.map((item, index) => {
          return (
            <Grid key={index}>
              <Grid.Row style={styles.listMain}>
                <Grid.Column style={styles.textIner} textAlign="left" width={9}>
                  {item.category.value}
                </Grid.Column>
                <Grid.Column
                  textAlign="right"
                  width={7}
                  style={styles.valueIner}
                >
                  {displayValue(
                    item.amt_cur.value,
                    item.currency || currency,
                    percentage
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          );
        })}
      </div>
    </Grid.Column>
  );
};

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    paddingBottom: 20,
    paddingLeft: 20,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none"
  },
  listMain: {
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#f2f2f6",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    alignSelf: "center",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 0,
    paddingRight: 0,
    marginLeft: 15,
    marginRight: 15
  },
  valueIner: {
    fontSize: 16,
    fontWeight: 400,
    color: "#575757",
    fontFamily: "Roboto"
  },
  textIner: {
    fontSize: 14,
    fontWeight: 300,
    color: "#999999",
    fontFamily: "Roboto",
    textTransform: "capitalize"
  },
  values: {
    paddingTop: 10,
    // maxHeight:'370px',
    // overflowY:'scroll',
    // overflowX:'hidden',
    paddingBottom: 10,
    marginBottom: 30,
    height: 330,
    minHeight: 330,
    fontFamily: "Roboto",
    borderStyle: "solid",
    flexDirection: "row",
    justifyContent: "space-around",
    borderTopWidth: 1,
    borderTopColor: "#c1c1c5",
    textTransform: "capitalize"
  }
};

export default LisData;



// WEBPACK FOOTER //
// ./src/components/ListData/index.js